import './index.css'
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { Dialog } from '@progress/kendo-react-dialogs'

import LoadingOverlay from 'components/Common/Overlay/LoadingOverlay'
import { Box, Typography, Divider} from '@mui/material'
import Button from 'components/Common/Button'

import { VaultAPI } from 'api'
import { stringUtils } from 'utils'

const VaultBODHistoryPopup = ({ document, onClose = () => {} }) => {
    const [pageNo, setPageNo] = useState(1)
    const [pageSize] = useState(5)
    const [total, setTotal] = useState(-1)
    const [loading, setLoading] = useState(false)
    const [history, setHistory] = useState([])
    const [loadMore, setLoadMore] = useState(false)

    const [error, setError] = useState('')

    useEffect(() => {
        if (!document.t_beneficial_owner_id) return

        setLoading(true)
        VaultAPI.fetchBODHistory(pageNo, pageSize, document.t_beneficial_owner_id)
            .then(res => {
                setTotal(res.rec_count)
                setHistory(history=>[...history, ...res.details])
            })
            .catch(err => {
                setError("")
                setLoadMore(false)
            })
            .finally(() => {
                setLoading(false)
            })

    }, [pageNo, pageSize, document.t_beneficial_owner_id])

    useEffect(() => {
        if (!history.length) return
        setLoadMore(history.length !== total)
    }, [history, total])

    const onLoadMore = () => {
        const newPageNo = pageNo + 1
        setPageNo(newPageNo)
        setLoading(true)
        VaultAPI.fetchBODHistory(pageNo, pageSize, document.t_beneficial_owner_id)
            .then(res => {
                setHistory([...history, ...res.details])
            })
            .catch(err => {
                setError("")
                setLoadMore(false)
            })
            .finally(() => {
                setLoading(false)
            })
    }
    return (
        <Box>
             <Dialog width="580px" height="400px">
             <Box textAlign="center" marginY="35px">
                 <Typography variant='h5' fontSize='24px' fontWeight='600' color='#25245F'>History</Typography>
             </Box>
             {loading && (
                 <LoadingOverlay
                     style={{
                         top: 0,
                         left: 0,
                         fontSize: '3rem',
                     }}
                 />
             )}
             {!!error.length && <div className="color-danger k-text-center text-lg k-bg-transparent">{error}</div>}
             {!loading && !history.length && !error.length && (
                 <h4 className="color-primary k-text-center k-mt-10">No history found...</h4>
             )}
             <div className="vault-document-history-content">
                 <ul>
                     {history.map(item => (
                         <li className="k-my-2">
                             <div className="vault-document-history-item ">
                                <Box display="flex" flexDirection="row" gap="40px">
                                  <Box width="160px">
                                     <span className="text-bold color-secondary">
                                       {moment(item.activity_date).format('MM/DD/YYYY')}
                                     </span>&nbsp;&nbsp;
                                     <span className="color-secondary">
                                     {moment(item.activity_date).format('hh:mm a')}
                                     </span>
                                  </Box>
                                  <Box paddingLeft="5px">
                                     <span className="color-primary">
                                       {stringUtils.camelCaseToNormal(item.operation)}
                                     </span>{' '}
                                     <span className="color-primary">by</span> {' '}
                                     <span className="color-primary">{item.activity_by}</span>
                                  </Box>
                                </Box>
                                 {history.length > 1 && (
                                 <Box marginTop="15px" marginBottom="15px">
                                    <Divider
                                     variant="start"
                                     sx={{  width: '436px', color:"#0a78cd" }}    
                                    />
                                  </Box>
                                  )}
                             </div>
                         </li>
                     ))}               
                     {!!loadMore && (
                         <button className="button button-secondary margin-auto" onClick={onLoadMore} >
                             Load more...
                         </button>
                     )}
                 </ul>
             </div>
             <Box textAlign="center">
                <Button
                  onClick = {onClose}
                  sx={{ width: '250px', fontWeight: 'bold', height:"50px" }}
                 >
                   Close
             </Button>
             </Box>
         </Dialog>   
        </Box>
    )
}

export default VaultBODHistoryPopup
